import { computed, ref } from 'vue';
import PendingMarketUpdatesAPI from 'dashboard/api/pendingMarketUpdates';
import { useAlert } from 'dashboard/composables';

export function usePendentesBlacklist({ actorPayload, onChanged }) {
  const blacklistEntries = ref([]);
  const blacklistSearch = ref('');
  const blacklistPhone = ref('');
  const blacklistReason = ref('');
  const isLoadingBlacklist = ref(false);
  const savingBlacklist = ref(false);
  const removingBlacklistId = ref('');

  const isSavingBlacklist = computed(
    () => savingBlacklist.value || Boolean(removingBlacklistId.value)
  );
  const canCreateBlacklistEntry = computed(
    () =>
      blacklistPhone.value.trim().length >= 8 &&
      blacklistReason.value.trim().length >= 5 &&
      !isSavingBlacklist.value
  );

  async function loadBlacklist() {
    isLoadingBlacklist.value = true;
    try {
      const { data } = await PendingMarketUpdatesAPI.blacklist({
        q: blacklistSearch.value,
        limit: 100,
      });
      blacklistEntries.value = data?.items || [];
    } catch (error) {
      useAlert(
        error.response?.data?.error ||
          error.response?.data?.details?.detail ||
          'Não foi possível carregar a blacklist.'
      );
    } finally {
      isLoadingBlacklist.value = false;
    }
  }

  async function createBlacklistEntry() {
    if (!canCreateBlacklistEntry.value) return;
    savingBlacklist.value = true;
    try {
      const { data } = await PendingMarketUpdatesAPI.createBlacklist({
        ...actorPayload.value,
        phone: blacklistPhone.value.trim(),
        reason: blacklistReason.value.trim(),
        source: 'chatwoot_manual',
        sourceLabel: 'Cadastro manual no Chatwoot',
      });
      useAlert(data?.message || 'Telefone adicionado à blacklist.');
      blacklistPhone.value = '';
      blacklistReason.value = '';
      await loadBlacklist();
      await onChanged();
    } catch (error) {
      useAlert(
        error.response?.data?.error ||
          error.response?.data?.details?.detail ||
          'Não foi possível adicionar o telefone à blacklist.'
      );
    } finally {
      savingBlacklist.value = false;
    }
  }

  async function removeBlacklistEntry(entry) {
    if (!entry?.id || removingBlacklistId.value) return;
    removingBlacklistId.value = String(entry.id);
    try {
      const { data } = await PendingMarketUpdatesAPI.deactivateBlacklist(
        entry.id,
        actorPayload.value
      );
      useAlert(data?.message || 'Telefone removido da blacklist ativa.');
      await loadBlacklist();
      await onChanged();
    } catch (error) {
      useAlert(
        error.response?.data?.error ||
          error.response?.data?.details?.detail ||
          'Não foi possível remover o telefone da blacklist.'
      );
    } finally {
      removingBlacklistId.value = '';
    }
  }

  function closeBlacklistDialog() {
    blacklistSearch.value = '';
  }

  return {
    blacklistEntries,
    blacklistSearch,
    blacklistPhone,
    blacklistReason,
    isLoadingBlacklist,
    savingBlacklist,
    removingBlacklistId,
    isSavingBlacklist,
    canCreateBlacklistEntry,
    loadBlacklist,
    createBlacklistEntry,
    removeBlacklistEntry,
    closeBlacklistDialog,
  };
}
